import React, { Component } from "react";
import { Link } from "react-router-dom";
import HeaderNav from "./common/HeaderNav";
import Footer from "./Footer";
import blogsBanner from "../images/blogs.png";
import apiCall from "../utils/apiCall";

let mountLimit = 1;
let retryLimit = 1;

class Blogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      blogs: [], // Store fetched blogs
      loading: false, // Show loading state while fetching
      error: null, // Handle errors
      blogsLimit: 20,
    };
  }

  async componentDidMount(filterData = null) {
    window.scrollTo(0, 0);
    document.title =
      "VIP Number Studio Blog - Insights on VIP Mobile Numbers & Trends";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Stay updated with the latest insights, trends, and tips on VIP mobile numbers. Explore articles on selecting premium numbers, industry news, and more at VIP Number Studio's blog."
      );
    if (mountLimit === 1 || retryLimit === 2) {
      mountLimit++;
      try {
        console.log("Fetching blogs...");
        let getBlogs = {};

        if (filterData) {
          filterData.status = [1];
          const { result } = await apiCall(
            "REACT_APP_GET_BLOG",
            "POST",
            filterData,
            false
          );
          getBlogs = result;
        } else {
          const { result } = await apiCall("REACT_APP_GET_BLOG", "POST", {
            limit: this.state.blogsLimit || 20,
            skip: 0,
            status: [1],
          });
          getBlogs = result;
        }

        console.log("getBlogs", getBlogs);

        if (getBlogs && getBlogs["success"] && getBlogs["data"]) {
          this.setState({
            blogs: getBlogs.data,
            totalBlogsSize: getBlogs.totalSize,
            loading: false,
            loadMoreBlogsLimit: this.state.blogsLimit,
          });
          retryLimit = 1;
        } else if (retryLimit === 1) {
          console.log("Retrying fetch...");
          retryLimit++;
          this.componentDidMount(null);
        }

        this.setState({
          currentWidth: window.innerWidth,
          openMobileFilter: false,
        });
      } catch (error) {
        console.log("Blogs componentDidMount Error ::", error);
        this.setState({
          error: "Failed to load blogs. Please try again later.",
          loading: false,
        });
      }

      setTimeout(() => {
        mountLimit = 1;
      }, 500);
    }
  }

  render() {
    const { blogs, loading, error } = this.state;

    return (
      <div className="blogs-page">
        <HeaderNav activeTabName="blogs" />
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "300px",
            overflow: "hidden",
            marginTop: "65px",
          }}
        >
          {/* Background Image */}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundImage: `url(${blogsBanner})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>

          {/* Gradient Overlay */}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background: "#000040",
            }}
          ></div>
          {/* Red circular accent */}
          <div
            style={{
              position: "absolute",
              width: "300px",
              height: "300px",
              backgroundColor: "rgba(255, 0, 0, 0.8)",
              borderRadius: "50%",
              top: "-150px",
              right: "-100px",
              zIndex: 1,
            }}
          ></div>

          {/* Second red circular accent */}
          <div
            style={{
              position: "absolute",
              width: "150px",
              height: "150px",
              backgroundColor: "rgba(255, 0, 0, 0.8)",
              borderRadius: "50%",
              bottom: "-70px",
              left: "50px",
              zIndex: 1,
            }}
          ></div>

          {/* Decorative dots */}
          <div
            style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              display: "flex",
              gap: "5px",
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              }}
            ></div>
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              }}
            ></div>
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              }}
            ></div>
          </div>

          {/* Decorative triangle */}
          <div
            style={{
              position: "absolute",
              bottom: "15px",
              right: "60px",
              width: 0,
              height: 0,
              borderLeft: "15px solid transparent",
              borderRight: "15px solid transparent",
              borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
              transform: "rotate(45deg)",
            }}
          ></div>

          {/* Content Container */}
          <div
            style={{
              position: "relative",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "0 20px",
              zIndex: "2",
            }}
          >
            <h1
              style={{
                color: "white",
                fontSize: "42px",
                fontWeight: "800",
                marginBottom: "16px",
                textAlign: "center",
                textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
              }}
            >
              Blogs & Articles
            </h1>

            <p
              style={{
                color: "white",
                fontSize: "18px",
                fontWeight: "400",
                maxWidth: "700px",
                textAlign: "center",
                textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
              }}
            >
              Read our latest blogs and articles to stay updated.
            </p>

            {/* Decorative Line */}
            <div
              style={{
                width: "80px",
                height: "4px",
                background:
                  "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
                marginTop: "20px",
                borderRadius: "2px",
              }}
            ></div>
          </div>
        </div>

        <div className="container my-5">
          <div className="section-header">
            <h2 className="section-title">
              VIP Number Studio Blog - Latest Articles on VIP Mobile Numbers
            </h2>
            <div className="section-divider">
              <span></span>
            </div>
          </div>

          {error ? (
            <div className="error-container">
              <i className="fas fa-exclamation-circle error-icon"></i>
              <p className="error-message">{error}</p>
            </div>
          ) : blogs.length === 0 ? (
            <div className="empty-container">
              <p>
                No articles available at the moment. Please check back soon!
              </p>
            </div>
          ) : (
            <>
              <div className="row">
                {blogs.map((blog) => (
                  <div key={blog.id} className="col-lg-4 col-md-6 mb-4">
                    <div className="blog-card">
                      <div className="blog-card-img-container">
                        <img src={blog.imageUrl} alt={blog.title} />
                      </div>
                      <div className="blog-card-content">
                        <h3 className="blog-card-title">{blog.title}</h3>
                        <p className="blog-card-excerpt">{blog.description}</p>
                        <div className="blog-card-footer">
                          <span className="blog-card-author">
                            {blog.author ? `By ${blog.author}` : ""}
                          </span>
                          <Link
                            to={`/blogs/blog-details?id=${blog.id}`}
                            className="btn-read-more"
                          >
                            Read More
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {this.state.totalBlogsSize > blogs.length && (
                <div className="text-center mt-4">
                  <button className="btn-load-more">Load More Articles</button>
                </div>
              )}
            </>
          )}
        </div>

        <Footer />
      </div>
    );
  }
}

export default Blogs;
